import * as moment from 'moment-timezone';
import { Port } from './port';
import { ShippingLine } from './shipping-line';
import { BookingInterface } from '../interfaces/api';
import { Vehicle } from './vehicle';
import { BookingStatus, BookingType } from '../types/booking';
import { VehicleType } from './vehicle-type';

export class Booking implements BookingInterface {

    id: number;

    reference: string;

    status: BookingStatus;

    type: BookingType;

    consignment_number: string;

    loaded: boolean;

    live_stock: boolean;

    hazardous: boolean;

    plug_in: boolean;

    main_deck: boolean;

    drivers: number;

    contact_email: string;

    contact_name: string;

    contact_number: string;

    notes: string;

    vehicle: Vehicle;

    private _vehicle_type: VehicleType;

    set vehicle_type(vehicleType: VehicleType) {
        this._vehicle_type = vehicleType;
        if (this.vehicle === undefined) this.vehicle = new Vehicle();
        this.vehicle.type = this._vehicle_type;
    }

    get vehicle_type(): VehicleType {
        return this._vehicle_type;
    }

    private _arriving_at: any;

    get arriving_at(): any {
        if (this._arriving_at === undefined || !this._arriving_at) return;
        let arriving_at = moment(this._arriving_at),
            port = this.arrival_port,
            timezone = null;
        if (port && port.timezone) timezone = port.timezone;
        if (timezone) arriving_at.tz(timezone.tz);
        return arriving_at;
    }

    set arriving_at(timestamp: any) {
        this._arriving_at = timestamp;
    }

    private _departing_at: any;

    get departing_at(): any {
        if (this._departing_at === undefined || !this._departing_at) return;
        let departing_at = moment(this._departing_at);

        let port = this.departure_port;
        let timezone = null;
        if (port && port.timezone) timezone = port.timezone;
        if (timezone) departing_at.tz(timezone.tz);

        return departing_at;
    }

    set departing_at(timestamp: any) {
        this._departing_at = timestamp;
    }

    private _created_at: any;

    get created_at(): any {
        return moment(this._created_at);
    }

    set created_at(timestamp: any) {
        this._created_at = timestamp;
    }

    private _updated_at: any;

    get updated_at(): any {
        return moment(this._updated_at);
    }

    set updated_at(timestamp: any) {
        this._created_at = timestamp;
    }

    arrival_port: Port;

    departure_port: Port;

    shipping_line: ShippingLine;

    durationFormatted(): string {
        if (this.arriving_at === undefined  || !this.arriving_at ||
            this.departing_at === undefined || !this.departing_at) return '';
        let duration: number = moment.duration(this.arriving_at.diff(this.departing_at)).asSeconds();
        let durationParts: string[] = [];

        let days: number = duration / (60 * 60 * 24);
        if (days >= 1) {
            days = Math.floor(days);
            duration -= days * 60 * 60 * 24;
            durationParts.push(days + 'd');
        }

        let hours: number = duration / (60 * 60);
        if (hours >= 1) {
            hours = Math.floor(hours);
            duration -= hours * 60 * 60;
            durationParts.push(hours + 'h');
        }

        let minutes: number = Math.round(duration / 60);
        durationParts.push(minutes + 'mins');

        return durationParts.join(' ');
    }

    static createFromObject(object: any): Booking {
        let booking: Booking = new Booking();

        if (object.arrival_port !== undefined)
            booking.arrival_port = Port.createFromObject(object.arrival_port);
        if (object.departure_port !== undefined)
            booking.departure_port = Port.createFromObject(object.departure_port);
        if (object.shipping_line !== undefined)
            booking.shipping_line = ShippingLine.createFromObject(object.shipping_line);
        if (object.vehicle !== undefined)
            booking.vehicle = Vehicle.createFromObject(object.vehicle);
        if (booking.vehicle !== undefined && booking.vehicle.type !== undefined)
            booking.vehicle_type = booking.vehicle.type;
        if (object.vehicle_type !== undefined)
            booking.vehicle_type = VehicleType.createFromObject(object.vehicle_type);

        if (object.consignment_number !== undefined)    booking.consignment_number = object.consignment_number;
        if (object.arriving_at !== undefined)           booking.arriving_at = object.arriving_at;
        if (object.created_at !== undefined)            booking.created_at = object.created_at;
        if (object.departing_at !== undefined)          booking.departing_at = object.departing_at;
        if (object.id !== undefined)                    booking.id = object.id;
        if (object.reference !== undefined)             booking.reference = object.reference;
        if (object.status !== undefined)                booking.status = object.status;
        if (object.updated_at !== undefined)            booking.updated_at = object.updated_at;

        booking.loaded = true;
        if (object.loaded !== undefined) booking.loaded = object.loaded == 1;
        booking.live_stock  = (object.live_stock !== undefined && object.live_stock == 1);
        booking.hazardous   = (object.hazardous !== undefined && object.hazardous == 1);
        booking.plug_in     = (object.plug_in !== undefined && object.plug_in == 1);
        booking.main_deck   = (object.main_deck !== undefined && object.main_deck == 1);
        booking.drivers     = object.drivers !== undefined ? object.drivers : 0;

        if (object.contact_email !== undefined)         booking.contact_email = object.contact_email;
        if (object.contact_name !== undefined)          booking.contact_name = object.contact_name;
        if (object.contact_number !== undefined)        booking.contact_number = object.contact_number;

        if (object.notes !== undefined)                 booking.notes = object.notes;

        return booking;
    }

    static createFromObjects(bookings: any[]): Booking[] {
        let objects: Booking[] = [];
        for (let booking of bookings) {
            objects.push(Booking.createFromObject(booking));
        }
        return objects;
    }
}



// WEBPACK FOOTER //
// ./src/entities/booking.ts